import { Link, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: 56,
    display: 'flex',
    alignItems: 'center',
    padding: '14px 18px 10px',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  name: {
    fontSize: '1rem',
    fontWeight: 680,
    letterSpacing: '-0.015em',
    color: 'var(--ar-fg)',
  },
});

/**
 * The compact mark and the product name. The rail is labelled now (RAIL_WIDTH
 * in modules/theme), so the name fits beside the mark.
 *
 * No aria-label: one would override the mark's own alt text, and "Home" is what
 * the rail's Home item is already called — two links to "/" with the same
 * accessible name. Falling through to the alt makes this one "AnswerRocket".
 */
export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  // Unpinned, the rail is 72px: the mark alone fits, the name does not.
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link}>
        <LogoIcon />
        {isOpen && (
          <span className={classes.name} aria-hidden="true">
            Catalog
          </span>
        )}
      </Link>
    </div>
  );
};
